import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, useEffect, useState } from 'react';
import Input from '../../../Input/rn';
import { View, TouchableOpacity, Text, StyleSheet, Platform } from 'react-native';
import { CountryPicker, countryCodes } from 'react-native-country-codes-picker';
import { gray_6, brand } from '../../../../styles/rn';
import parsePhoneNumber from 'libphonenumber-js';
import { FormContext, ModeType, ValidateStatusType } from '..';
import DownArrow from '../../../Image/rn/DownArrow';
var styles = StyleSheet.create({
  phoneNumEditItemWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 12,
    paddingLeft: 12,
    paddingTop: 12
  },
  phoneNumWrapper: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  countryCodeText: {
    paddingRight: 8,
    paddingLeft: 8,
    paddingTop: 7,
    paddingBottom: 7,
    textAlign: 'center'
  },
  countryCodeTextEdit: {
    paddingRight: 8,
    paddingLeft: 8,
    paddingTop: 7,
    paddingBottom: 7,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: gray_6,
    backgroundColor: 'white'
  },
  inputWrapper: {
    flex: 1,
    paddingLeft: 8
  },
  itemErrMsg: {
    color: brand
  },
  itemErrMsgWithPadding: {
    color: brand,
    paddingLeft: 12
  },
  downArrowIcon: {
    width: 24,
    height: 16
  }
});
export default (function (props) {
  var _abbreviation$toLocal;
  var value = props.value,
    onChange = props.onChange,
    mode = props.mode;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    countryCode = _useState4[0],
    setCountryCode = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    abbreviation = _useState6[0],
    setAbbreviation = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    phoneNum = _useState8[0],
    setPhoneNum = _useState8[1];
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errMsg = _React$useState2[0],
    setErrMsg = _React$useState2[1];
  var formContext = useContext(FormContext);
  useEffect(function () {
    if ((formContext === null || formContext === void 0 ? void 0 : formContext.validateStatus) === ValidateStatusType.Validating) {
      var _formContext$handleFo;
      var res = handleValidate(phoneNum, countryCode);
      formContext === null || formContext === void 0 ? void 0 : (_formContext$handleFo = formContext.handleFormItemValidate) === null || _formContext$handleFo === void 0 ? void 0 : _formContext$handleFo.call(formContext, _defineProperty({}, props.name, res ? res : ValidateStatusType.Success));
    }
  }, [phoneNum, countryCode, formContext === null || formContext === void 0 ? void 0 : formContext.validateStatus]);
  var handleValidate = function handleValidate(value, countryCode) {
    if (props.required) {
      if (!value || !countryCode) {
        setErrMsg('The Field is required');
        return 'The Field is required';
      }
    }
    setErrMsg('');
  };
  useEffect(function () {
    if (countryCode) {
      return;
    }
    if (!value) {
      // 默认当前地区的区号
      var country = countryCodes.find(function (item) {
        var _props$region;
        return item.code === (props === null || props === void 0 ? void 0 : (_props$region = props.region) === null || _props$region === void 0 ? void 0 : _props$region.toLocaleUpperCase());
      });
      setCountryCode("".concat(country === null || country === void 0 ? void 0 : country.dial_code));
      setAbbreviation(country === null || country === void 0 ? void 0 : country.code);
      return;
    }
    var v = value.replace(/^\+/g, '');
    var phoneNumber = parsePhoneNumber("+".concat(v));
    if (phoneNumber) {
      setCountryCode("+".concat(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.countryCallingCode));
      setAbbreviation(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.country);
      var nationalNumber = (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.nationalNumber) || '';
      nationalNumber.replace(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.countryCallingCode, '');
      setPhoneNum(nationalNumber);
    } else {
      // 区号设置为当前地区的区号
      var _country = countryCodes.find(function (item) {
        var _props$region2;
        return item.code === (props === null || props === void 0 ? void 0 : (_props$region2 = props.region) === null || _props$region2 === void 0 ? void 0 : _props$region2.toLocaleUpperCase());
      });
      if (_country) {
        setPhoneNum(v);
        setCountryCode("".concat(_country === null || _country === void 0 ? void 0 : _country.dial_code));
        setAbbreviation(_country === null || _country === void 0 ? void 0 : _country.code);
      } else {
        setPhoneNum(v);
      }
    }
  }, [value, countryCode]);
  var handlePhoneNumber = function handlePhoneNumber(value) {
    setPhoneNum(value);
    onChange === null || onChange === void 0 ? void 0 : onChange("".concat(countryCode).concat(value));
    handleValidate(value, countryCode);
  };
  var typeProps = Platform.OS === 'web' ? {
    type: 'tel',
    inputmode: 'tel'
  } : {
    keyboardType: 'phone-pad'
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: [ModeType.EditItem].includes(mode) ? styles.phoneNumEditItemWrapper : styles.phoneNumWrapper
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: [ModeType.Edit, ModeType.EditItem].includes(mode) ? function () {
      return setShow(true);
    } : undefined
  }, /*#__PURE__*/React.createElement(View, {
    style: [ModeType.Edit, ModeType.EditItem].includes(mode) ? styles.countryCodeTextEdit : styles.countryCodeText
  }, /*#__PURE__*/React.createElement(Text, null, abbreviation === null || abbreviation === void 0 ? void 0 : (_abbreviation$toLocal = abbreviation.toLocaleUpperCase) === null || _abbreviation$toLocal === void 0 ? void 0 : _abbreviation$toLocal.call(abbreviation), " ", countryCode), [ModeType.Edit, ModeType.EditItem].includes(mode) ? /*#__PURE__*/React.createElement(View, {
    style: {
      paddingLeft: 8
    }
  }, /*#__PURE__*/React.createElement(DownArrow, {
    style: styles.downArrowIcon
  })) : null)), /*#__PURE__*/React.createElement(View, {
    style: styles.inputWrapper
  }, [ModeType.Checking, ModeType.View].includes(mode) ? /*#__PURE__*/React.createElement(Text, null, phoneNum) : null, [ModeType.Edit, ModeType.EditItem].includes(mode) ? /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    value: phoneNum,
    onChange: handlePhoneNumber
  }, typeProps)) : null)), /*#__PURE__*/React.createElement(View, null, !!errMsg && !([ModeType.EditItem].includes(mode) && !phoneNum) ? /*#__PURE__*/React.createElement(Text, {
    style: mode === ModeType.Checking ? styles.itemErrMsg : styles.itemErrMsgWithPadding
  }, errMsg) : null), /*#__PURE__*/React.createElement(CountryPicker, {
    show: show,
    style: {
      modal: {
        height: 400
      },
      textInput: {
        height: 40,
        borderRadius: 0,
        backgroundColor: 'white'
      }
    },
    lang: "en",
    onBackdropPress: function onBackdropPress() {
      return setShow(false);
    },
    pickerButtonOnPress: function pickerButtonOnPress(item) {
      setCountryCode(item.dial_code);
      setAbbreviation(item.code);
      onChange === null || onChange === void 0 ? void 0 : onChange("".concat(item.dial_code).concat(phoneNum));
      handleValidate(phoneNum, item.dial_code);
      setShow(false);
    }
  }));
});